import React from "react";
import { Link, useLocation } from "react-router-dom";
import Copyright from "./copyright";
import { CONTACT_INFO } from "../../util/constants";

export default function FooterV1() {
  let publicUrl = process.env.PUBLIC_URL + "/";

  const { pathname } = useLocation();

  const rightPath = (path) => {

    if (pathname === '/') {
      return path;
    }

    return '/' + path;
  };

  return (
    <footer className="ltn__footer-area  ">
      <div className="footer-top-area  section-bg-2 plr--5">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center">
            <div className="col-xl-4 col-md-4 col-sm-6 col-12">
              <div className="footer-widget footer-about-widget">
                <div className="footer-logo">
                  <div className="site-logo">
                    <img
                      src={publicUrl + "assets/img/logo-full.png"}
                      alt="Logo Grupo Terra"
                      loading="lazy"
                    />
                  </div>
                </div>
                <p>Grupo Terra - Gente feliz fazendo bons negócios!</p>
                <div className="footer-address">
                  <ul>
                    <li>
                      <div className="footer-address-icon colored-footer-icon" aria-hidden="true">
                        <i className="fab fa-whatsapp"></i>
                      </div>
                      <div className="footer-address-info">
                        <p>
                          <a href={`tel:+${CONTACT_INFO.PHONE.WHATSAPP}`} aria-label="WhatsApp: {CONTACT_INFO.PHONE.FORMATTED}">
                            {CONTACT_INFO.PHONE.FORMATTED}
                          </a>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="footer-address-icon" aria-hidden="true">
                        <i className="fa-solid fa-phone"></i>
                      </div>
                      <div className="footer-address-info">
                        <p>
                          <a href={`tel:+${CONTACT_INFO.PHONE.WHATSAPP}`} aria-label="Telefone: {CONTACT_INFO.PHONE.SAC}">
                            {CONTACT_INFO.PHONE.SAC}
                          </a>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="footer-address-icon" aria-hidden="true">
                        <i className="fa-solid fa-envelope"></i>
                      </div>
                      <div className="footer-address-info">
                        <p>
                          <a href={`mailto:${CONTACT_INFO.EMAIL.SALES}`} aria-label="E-mail de vendas: {CONTACT_INFO.EMAIL.SALES}">
                            {CONTACT_INFO.EMAIL.SALES}
                          </a>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="footer-address-icon" aria-hidden="true">
                        <i className="fa-solid fa-envelope"></i>
                      </div>
                      <div className="footer-address-info">
                        <p>
                          <a href={`mailto:${CONTACT_INFO.EMAIL.ADMIN}`} aria-label="E-mail administrativo: {CONTACT_INFO.EMAIL.ADMIN}">
                            {CONTACT_INFO.EMAIL.ADMIN}
                          </a>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-4 col-sm-6 col-12">
            </div>
            <div className="col-xl-4 col-md-4 col-sm-12 col-12">
              <div className="footer-widget footer-menu-widget clearfix">
                <h4 className="footer-title" id="footer-menu-title">Nossas áreas</h4>
                <div className="footer-menu">
                  <ul aria-labelledby="footer-menu-title">
                    <li>
                      <a href={rightPath("#home")} aria-label="Ir para a seção Home">Home</a>
                    </li>
                    <li>
                      <a href={rightPath("#products")} aria-label="Ir para a seção de Produtos">Produtos</a>
                    </li>
                    <li>
                      <a href={rightPath("#about-us")} aria-label="Ir para a seção Sobre nós">Sobre nós</a>
                    </li>
                    <li>
                      <a href={rightPath("#contact")} aria-label="Ir para a seção de Contato">Contato</a>
                    </li>
                    <li>
                      <Link
                        to="/termos-e-politicas"
                        aria-label="Termos de Uso e Política de Privacidade"
                        title="Termos de uso e política de privacidade"
                      >
                        Termos e Privacidade
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Copyright />
    </footer>
  );
}
